import { useEffect, useState } from "react";
import { subscribeOdooLiveChatLoad } from "services/odoo-live-chat/odoo-live-chat";
import { useAuth } from "stores/auth/auth-context";

import { IUseOdooLiveChatLoader } from "./use-odoo-live-chat-loader.types";

const odooUrl = process.env.NEXT_PUBLIC_ODOO_LIVECHAT_URL;
const channelId = process.env.NEXT_PUBLIC_ODOO_LIVECHAT_CHANNEL_ID;

// Decides when the Odoo bundle may be injected. The loader must run before
// assets_embed.js (it sets odoo.__session_info__), so the bundle is only
// allowed once the loader has finished loading. Only for logged in users, and
// only once the visitor clicks Coco (or has a chat in progress), so page views
// alone do not download the ~1.6 MB bundle or hit Odoo. Odoo's stock button is
// hidden because the launcher renders the Coco button instead.
export const useOdooLiveChatLoader = (): IUseOdooLiveChatLoader => {
  const { user } = useAuth();
  const isLoggedIn = user?.isUserLoggedIn || false;
  const [isLoaderReady, setIsLoaderReady] = useState(false);
  const [isLoadRequested, setIsLoadRequested] = useState(false);

  useEffect(() => {
    window.clLivechatConfig = { hideDefaultButton: true };
  }, []);

  useEffect(
    () => subscribeOdooLiveChatLoad(() => setIsLoadRequested(true)),
    []
  );

  const isEnabled =
    isLoggedIn && isLoadRequested && Boolean(odooUrl) && Boolean(channelId);

  return {
    isEnabled,
    isLoaderReady,
    loaderSrc: `${odooUrl}/im_livechat/loader/${channelId}`,
    assetsSrc: `${odooUrl}/im_livechat/assets_embed.js`,
    onLoaderLoad: () => setIsLoaderReady(true)
  };
};
